import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

export const initializeSocket = (token: string) => {
  if (!socket) {
    socket = io(`${process.env.REACT_APP_SERVER_URL}`, {
      transports: ['websocket'],
      withCredentials: true,
      auth: {
        token,
      },
      reconnectionAttempts: 3,
    });
  }
  return socket;
};

export const getSocket = (): Socket => {
  if (!socket) throw new Error('Socket not initialized!');
  return socket;
};